import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { ConfigurationAssaygroupCreateRequest, ConfigurationAssaygroupPatchInBatchRequest, ConfigurationAssaygroupResponse } from '@/modules/configurationModule/detail/assays/configuration-assays-groups/services/configuration-assaygroup/configuration-assaygroup.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ConfigurationAssaygroupService {
    async create(request: ConfigurationAssaygroupCreateRequest): Promise<ConfigurationAssaygroupResponse> {
        const response = await axios.post<ConfigurationAssaygroupResponse>(`/configuration/assaygroups`, request)
        return response.data
    }

    async paginator(filterModel?: CommonFilterModel, params?: CommonParams): Promise<IResponseAgGrid<ConfigurationAssaygroupResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationAssaygroupResponse>>(`/configuration/assaygroups/`, { ...filterModel }, { params })
        return response.data
    }

    async delete(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/assaygroups/batch`, { data: request })
        return response.data
    }

    async patch(request: ConfigurationAssaygroupPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/assaygroups/batch`, request)
        return response.data
    }
}

export const configurationAssaygroupService = new ConfigurationAssaygroupService()
